import { SAMPLE__SET, SAMPLE__SET_NAME } from "@/store/mutation-types";

import SampleModel from "@/models/lab/SampleModel";

const getStored = (key) => {
  const val = localStorage.getItem(key);

  return val && val !== "" ? val : null;
};

const assignModel = (state, key, model) => {
  if (!model || !model.id) {
    model = null;
  }
  state[key] = model;
  if (model) {
    localStorage.setItem(key, JSON.stringify(model._attributes));
  } else {
    localStorage.removeItem(key);
  }
};
const getters = {
  getCurrentSample: (state) => state.sample__current,
  getCurrentSampleName: (state) => state.sample__name,
};

const state = {
  sample__current: getStored("sample__current")
    ? new SampleModel(JSON.parse(getStored("sample__current")))
    : null,
  sample__name: getStored("sample__name") ? getStored("sample__name") : null,
};

const mutations = {
  SAMPLE__SET(state, sample) {
    assignModel(state, "sample__current", sample);
  },
  SAMPLE__SET_NAME(state, sample) {
    state["sample__name"] = sample.publicNumber();
    localStorage.setItem("sample__name", state["sample__name"]);
  },
};

const actions = {
  SAMPLE__SET_CURRENT: ({ commit }, { sample }) => {
    commit(SAMPLE__SET_NAME, sample);
    
    return commit(SAMPLE__SET, sample);
  },

  async SAMPLE__FETCH_CURRENT({ commit }, { sample_id }) {
    const sample = new SampleModel({ id: sample_id });

    return sample.fetch().then(() => {
      commit(SAMPLE__SET_NAME, sample);
      return commit(SAMPLE__SET, sample);
    });
  },
};

export default {
  getters,
  mutations,
  actions,
  state,
};
